import { ReactNode } from "react";
import { createPortal } from "react-dom";

type ModalMessageProps = {
    headerTitle?: string;
    bodyTitle?: string;
    description?: string;
    bodyContent?: ReactNode;
    primaryButtonText: string;
    modalId: string;
    secondaryButtonText?: string;
    secondaryButtonAction?: () => void;
}

const ModalMessage = ({
    headerTitle,
    bodyTitle,
    description,
    bodyContent,
    primaryButtonText, 
    modalId, 
    secondaryButtonText, 
    secondaryButtonAction
}: ModalMessageProps) => {

    const showModalFooterBorder = description || bodyContent;

    return (
        createPortal(
            <div className="modal modal-message" id={modalId} role="dialog"
                aria-labelledby="mySmallModalLabel">
                <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                        {headerTitle && <h3 className="modal-header">{headerTitle}</h3>} 
                        <div className="modal-body">
                            {bodyTitle && <h3>{bodyTitle}</h3>}
                            {description && <p>{description}</p>}
                            {bodyContent}
                        </div>
                        <div className={`modal-footer ${showModalFooterBorder ? "border-top" : ""}`}>
                            {secondaryButtonText && secondaryButtonAction &&
                                <button type="button"
                                        onClick={secondaryButtonAction}
                                        className="btn btn-default"
                                        data-dismiss="modal">
                                    {secondaryButtonText}
                                </button>
                            }

                            <button type="button" className="btn btn-primary" data-dismiss="modal">{primaryButtonText}</button>
                        </div>
                    </div>
                </div>
            </div>
        , document.body)
    );
}

const showModalMessage = (modalId: string) => { $("#" + modalId).modal("show") };

export {
    ModalMessage,
    showModalMessage
}